import { render, staticRenderFns } from "./Video_tutorial.vue?vue&type=template&id=d5e27588&scoped=true&"
import script from "./Video_tutorial.vue?vue&type=script&lang=js&"
export * from "./Video_tutorial.vue?vue&type=script&lang=js&"
import style0 from "./Video_tutorial.vue?vue&type=style&index=0&id=d5e27588&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e27588",
  null
  
)

export default component.exports